// Delete Customer/Supplier → "Add Credit/Payment" → Done. The settlement entry pops back to
// the profile it was opened from, and the profile reopens the delete prompt, which now sees a
// zero balance. Mirrors KMP, where the Add Transaction screen pops back to DeleteAccount.
// The intent crosses a route change (and survives a reload) via sessionStorage, read once.
const KEY = 'okc_reopen_delete_after_settlement'

export const markDeleteAfterSettlement = (entityId: string): void => {
  try {
    sessionStorage.setItem(KEY, entityId)
  } catch (e) {
    // storage unavailable: the user just taps Delete again
  }
}

export const consumeDeleteAfterSettlement = (entityId: string): boolean => {
  try {
    const pending = sessionStorage.getItem(KEY)
    if (pending) {
      sessionStorage.removeItem(KEY)
    }
    return pending === entityId
  } catch (e) {
    return false
  }
}
